import {
  Collapsible,
  FlexBox,
  Icon,
  IconButton,
  Text,
} from '@dixa/lib-shared-habla';
import { useState } from 'react';

import {
  ChatbotToolParent,
  ToolExecutionData,
  ToolInput,
  ToolOutput,
  ToolType,
} from 'apis/auditLogs';

import {
  getToolCallText,
  ToolCallDetails,
} from '../chatbotToolCalled/toolCallDetails';
import styles from '../logEntry/logEntry.module.scss';

type ToolCallEntryRowProps = {
  tool_type: ToolType;
  tool_name: string;
  input: ToolInput;
  output: ToolOutput;
  execution_data?: ToolExecutionData;
  parent?: ChatbotToolParent;
};

export const ToolCallEntryRow = ({
  tool_type,
  tool_name,
  input,
  output,
  execution_data,
  parent,
}: ToolCallEntryRowProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toolCallText = getToolCallText(tool_type, tool_name);
  const secondaryText = parent ? `Procedure: ${parent.tool_name}` : null;

  return (
    <FlexBox gap="100" flexDirection="column" width="100%">
      <FlexBox flexDirection="row" alignItems="center" gap="200">
        <div className={styles.iconContainer}>
          <Icon name="wrench" size={16} />
        </div>
        <FlexBox flexDirection="column">
          <Text.Paragraph variant="3">{toolCallText}</Text.Paragraph>
          {secondaryText && (
            <Text.Paragraph variant="4" subdued>
              {secondaryText}
            </Text.Paragraph>
          )}
        </FlexBox>
        <IconButton
          onClick={() => setIsExpanded(!isExpanded)}
          icon={isExpanded ? 'angle-up' : 'angle-down'}
          variant="tertiary"
        />
      </FlexBox>
      <Collapsible isOpen={isExpanded} header={null}>
        <FlexBox padding="0 0 0 500" width="100%" boxSizing="border-box">
          <ToolCallDetails
            input={input}
            output={output}
            execution_data={execution_data}
          />
        </FlexBox>
      </Collapsible>
    </FlexBox>
  );
};
